import { animated } from "@react-spring/web";
import classcat from "classcat";
import React from "react";

import {
  Button,
  ConfirmationModal,
  IconCart,
  IconRefresh,
} from "@touchtech/web-baselayer-ui";

import css from "./UserActivityModal.module.css";
import useManageUserActivityModal from "./hooks/useManageUserActivityModal";

const UserActivityModal = () => {
  const {
    showUserActivityModal,
    handleContinueSearch,
    handleResetUserActivity,
    handleModalClick,
    handleModalClose,
    animatedRef,
    styles,
    t,
  } = useManageUserActivityModal();

  return (
    <div onClick={handleModalClick}>
      <ConfirmationModal
        isOpen={showUserActivityModal}
        onClose={handleModalClose}
      >
        <div className={css.modalContent}>
          <h1 className={classcat(["text-headline-5xl", css.title])}>
            {t("Are you still there?")}
          </h1>
          <span className={classcat(["text-label-xl", css.text])}>
            {t("Tap the button to continue or it will be automatically reset")}
          </span>
          <button
            ref={animatedRef}
            className={classcat([
              "text-button-xl text-white",
              css.letsContinueButton,
            ])}
            onClick={handleContinueSearch}
          >
            <animated.div className={css.animatedButtonFill} style={styles} />
            <animated.div className={css.animatedButtonContent}>
              <IconCart />
              {t("Yes, let's continue")}
            </animated.div>
          </button>
          <Button
            variant="tertiary"
            sizing="lg"
            className={css.startSearchButton}
            onClick={handleResetUserActivity}
            onTouchStart={handleResetUserActivity}
          >
            <IconRefresh />
            {t("Start a new search")}
          </Button>
        </div>
      </ConfirmationModal>
    </div>
  );
};

export default UserActivityModal;
